import * as actionTypes from '../_actions/actionTypes';
import { initialState } from './initialState';

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_DATA_SUCCESS:
            return executeGetDataSuccess(state, action);
        case actionTypes.POST_DATA_SUCCESS:
            return executePostDataSuccess(state, action);
        case actionTypes.PUT_DATA_SUCCESS:
            return executePutDataSuccess(state, action);
        case actionTypes.DELETE_DATA_SUCCESS:
            return executeDeleteDataSuccess(state, action);
        case actionTypes.OPEN_SESSION:
            return executePostSessionSuccess(state, action);
        case actionTypes.CREATE_SESSION:
            return executePostRegisterSuccess(state, action);
        case actionTypes.CLOSE_SESSION:
            return { }
        case actionTypes.SAVE_PARTNER_ID:
            return {
                ...state,
                partner: {
                    ...state.partner,
                    partnerId: action.payload
                }

            }
        case actionTypes.SAVE_PARTNER:
            return {
                ...state,
                partner: action.payload
            }
        default:
            return state;
    }
}
export default reducer;

const executePostSessionSuccess = (state, action) => {
    return {
        ...state,
        user: action.data,
        authenticated: true
    }
}

const executePostRegisterSuccess = (state, action) => {
    return {
        ...state,
        user: action.data,
        authenticated: true
    }
}

const executeGetDataSuccess = (state, action) => {
    return {
        ...state,
        data: action.data
    }
}

const executePostDataSuccess = (state, action) => {
    return {
        ...state,
        data: action.data
    }
}

const executePutDataSuccess = (state, action) => {
    return {
        ...state,
        data: action.data
    }
}

const executeDeleteDataSuccess = (state, action) => {
    return {
        ...state,
        data: action.data
    }
}